import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { successResponseSchema } from '@/api/schemas';

/**
 * Represents a request to resync a project from Salesforce.
 * This includes the project key to identify which project to resync.
 */
export interface SfdcResyncProject {
  projectKey: string;
}

/**
 * Triggers a resync of a project from Salesforce.
 * This queues the project for resynchronization with the latest data from Salesforce.
 *
 * @param props contains the project key
 */
export async function sfdcResyncProject(props: SfdcResyncProject) {
  const path = `/v1/crm/sfdc/objects/PROJECT/${props.projectKey}/resync`;
  const response = await api.post(path);

  return parseResponse(successResponseSchema, response.data, {
    schemaName: 'SfdcResyncProject',
    endpoint: path,
  });
}
